module.exports = __webpack_public_path__ + "static/img/logo03.2fc9df8a.jpg";